import { Component, OnInit } from '@angular/core';
import {FormArray, FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {SecretaireService} from "../../../services/secretaire.service";
import {MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-audiences',
  templateUrl: './audiences.component.html',
  styleUrls: ['./audiences.component.scss']
})
export class AudiencesComponent implements OnInit {
  audienceForm: FormGroup;
  selectedValue: string;
  selectedValue2: string;
  mois: any [] ;
  jours: any [] ;
  id: any ;

  constructor(
    private formBuilder: FormBuilder,
    private secretaireService: SecretaireService ,
    public dialogRef: MatDialogRef<AudiencesComponent>
  ) {
    this.mois=['Janvier','Fevrier','Mars','Avril','Mai','Juin','Juillet','Aout' , 'Septembre','Octobre','Novembre','Decembre'] ;
    this.jours=['1','2','3','4','5','6','7','8','9','10','11','12','13','14','15','16','17','18','19','20','21','22','23','24','25','26','27','28','29','30','31']
  }

  ngOnInit(): void {
    this.audienceForm = new FormGroup(
      {
        mois: new FormControl(null, Validators.required),
        jour: new FormControl(null , Validators.required),
        debutAudience: new FormControl(null , Validators.required),
        finAudience: new FormControl(null , Validators.required),
        demandeur: new FormControl(null , Validators.required),
        observations: new FormControl(null , Validators.required),
        agenda: new FormControl(null),
        archive: new FormControl(false),
      });
  }
  // tslint:disable-next-line:typedef
  get f() { return this.audienceForm.controls; }
  // tslint:disable-next-line:typedef
  // tslint:disable-next-line:typedef
  onSubmit3() {
    if (this.f.mois.value == 'Janvier') {
      this.f.agenda.setValue('api/secretaire/agenda/1')  ;
    }
    else if (this.f.mois.value == 'Fevrier'){
      this.f.agenda.setValue('api/secretaire/agenda/2')  ;
    }
    else if (this.f.mois.value == 'Mars'){
      this.f.agenda.setValue('api/secretaire/agenda/3')  ;
    }
    else if (this.f.mois.value == 'Avril'){
      this.f.agenda.setValue('api/secretaire/agenda/4')  ;
    }
    else if (this.f.mois.value == 'Mai'){
      this.f.agenda.setValue('api/secretaire/agenda/5')  ;
    }
    else if (this.f.mois.value == 'Juin'){
      this.f.agenda.setValue('api/secretaire/agenda/6')  ;
    }
    else if (this.f.mois.value == 'Juillet'){
      this.f.agenda.setValue('api/secretaire/agenda/7')  ;
    }
    else if (this.f.mois.value == 'Aout'){
      this.f.agenda.setValue('api/secretaire/agenda/8')  ;
    }
    else if (this.f.mois.value == 'Septembre'){
      this.f.agenda.setValue('api/secretaire/agenda/9')  ;
    }
    else if (this.f.mois.value == 'Octobre'){
      this.f.agenda.setValue('api/secretaire/agenda/10')  ;
    }
    else if (this.f.mois.value == 'Novembre'){
      this.f.agenda.setValue('api/secretaire/agenda/11')  ;
    }
    else if (this.f.mois.value == 'Decembre'){
      this.f.agenda.setValue('api/secretaire/agenda/12')  ;
    }
    //   this.submitted = true;
// reset alerts on submit
    // @ts-ignore
    // this.alertService.clear();
    // stop here if form is invalid
    this.secretaireService.addAudience(this.audienceForm.value)
      .subscribe(
        user => {
          this.audienceForm.reset() ;
          // window.location.reload() ;
          this.onClose() ;
        });
  }
  // tslint:disable-next-line:typedef
  onClose() {
    this.dialogRef.close() ;
  }

}
